enum ProfessorStatusEnum {
    ATESTADO_MEDICO = "100",
    ATIVO = "101",
    AUXILIO_DOENCA = "102",
    FERIAS = "103",
    INATIVO = "104",
    LICENCA_MATERNIDADE = "106",
    LICENCA_NAO_REMUNERADA = "107",
    LICENCA_REMUNERADA = "110",
    LICENCA_SINDICAL_NAO_REMUNERADA = "111",
    SUSPENSAO_CONTRATO_DE_TRABALHO = "112",
}

const ProfessorStatusEnumLabel = new Map<ProfessorStatusEnum, string>([
    [ProfessorStatusEnum.ATESTADO_MEDICO, "Atestado Médico"],
    [ProfessorStatusEnum.ATIVO, "Ativo"],
    [ProfessorStatusEnum.AUXILIO_DOENCA, "Auxílio Doença"],
    [ProfessorStatusEnum.FERIAS, "Férias"],
    [ProfessorStatusEnum.INATIVO, "Inativo"],
    [ProfessorStatusEnum.LICENCA_MATERNIDADE, "Licença Maternidade"],
    [ProfessorStatusEnum.LICENCA_NAO_REMUNERADA, "Licença Não Remunerada"],
    [ProfessorStatusEnum.LICENCA_REMUNERADA, "Licença Remunerada"],
    [
        ProfessorStatusEnum.LICENCA_SINDICAL_NAO_REMUNERADA,
        "Licença Sindical Não Remunerada",
    ],
    [
        ProfessorStatusEnum.SUSPENSAO_CONTRATO_DE_TRABALHO,
        "Suspensão Contrato de Trabalho",
    ],
]);

export { ProfessorStatusEnum, ProfessorStatusEnumLabel };
